import React from 'react';

import { AgentsFilters } from './AgentsFilters.container';
import { AgentsHeaderProps } from './AgentsHeader.decl';

import { Typography, Flex } from '@aircall/tractor-v2';
import { Gap } from '@dashboard/library';
import { Trans } from 'react-i18next';

export const AgentsHeader = React.memo(({ searchQuery, agentsTotal }: AgentsHeaderProps) => (
  <Gap gap='s' alignItems='center'>
    <AgentsFilters searchTerm={searchQuery} />

    {agentsTotal !== undefined ? (
      <Flex marginLeft='auto'>
        <Typography variant='bodyMediumS' textAlign='right' color='neutral-400'>
          <Trans i18nKey='users.search.total' values={{ agentsTotal }} />
        </Typography>
      </Flex>
    ) : undefined}
  </Gap>
));
